import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import Children from "./Children";

class Department extends PureComponent {
  static propTypes = {
    department: PropTypes.object,
    activeItem: PropTypes.object,
    active: PropTypes.bool,
    changeDepartment: PropTypes.func,
    isMobile: PropTypes.bool,
    changeProduct: PropTypes.func,
    minimized: PropTypes.bool
  };

  render() {
    const {
      department,
      changeDepartment,
      active,
      activeItem,
      isMobile,
      changeProduct,
      minimized
    } = this.props;
    return (
      <div
        className={`department other-products__item${
          active ? ` department_active` : ``
        }`}
        onClick={changeDepartment(department)}
      >
        <div className="department__title">{department.title}</div>
        {isMobile && (
          <div className="department__children">
            <Children
              activeItem={activeItem}
              items={department.children}
              changeProduct={changeProduct}
              minimized={minimized}
            />
          </div>
        )}
      </div>
    );
  }
}

export default Department;
